import React from 'react'
import News from './News';
import Hero from './Hero';
import Couses from './Couses';
import CourseCards from './CourseCards';
import Footer from './Footer';


import Cpro from '/Users/bibek/onlinePaathshala/onlinepaathshala/src/images/cpro.png';
import cplus from '../images/cplus.png';
import sql from '../images/sql.jpg';

import grabackground from '../images/gradientbackground.jpg'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Whyonlinepaathshala from '../Components/Whyonlinepaathshala';
import Workshopbanner from '../Components/Workshopbanner';


export default function Mainpage() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
   
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
          
        }
      }
    ]
  };
  return (
   <>
    <News />
        <Hero />
        {/* <div className='relative'> */}
          {/* <img src={grabackground} alt='gradientbackground' className='cover w-full h-[350px] opacity-50 '></img> */}
          {/* <div className=' absolute inset-0 mt-8'> */}
          <Whyonlinepaathshala></Whyonlinepaathshala>
          {/* </div> */}
          {/* </div> */}
      
          <Couses />
        <div className='relative h-auto mx-auto  md:mt-7 mt-0 flex flex-  gap-2 justify-around flex-wrap  '>
                    <img src={grabackground} alt='gradientbackground' className='fit w-full md:h-[400px] h-[1200px]  opacity-40 '></img>
                    
           <div className='absolute inset-0 container mx-auto  mt-7  flex flex-  md:gap-2 justify-center md:justify-between flex-wrap '>
         
              <div>
                <CourseCards
                  image={Cpro}
                  title='C Programming'
                  cost='1000'
                  instructor='Bibek Regmi'
                  days='45'
                  studentsno='150'
                />
              </div>
              <div>
                <CourseCards
                  image={cplus}
                  title='C++ Programming'
                  cost='1000'
                  instructor='Baiju Kumar'
                  days='45'
                  studentsno='150'
                />
              </div>
              <div>
                <CourseCards
                  image={sql}
                  title='SQL (Structural Query Language)'
                  cost='1000'
                  instructor='Bibek Regmi'
                  days='45'
                  studentsno='150'
                />
              </div >
              {/* <div className='px-3'>
                <CourseCards
                  image={htmlcss}
                  title='HTML/CSS'
                  cost='1000'
                  instructor='Bibek Regmi'
                  days='45'
                  studentsno='150'
                />
              </div>
              <div className='px-3'>
                <CourseCards
                  image={htmlcss}
                  title='HTML/CSS'
                  cost='1000'
                  instructor='Bibek Regmi'
                  days='45'
                  studentsno='150'
                />
              </div>
              <div className='px-3'>
                <CourseCards
                  image={htmlcss}
                  title='HTML/CSS'
                  cost='1000'
                  instructor='Bibek Regmi'
                  days='45'
                  studentsno='150'
                />
              </div> */}
            
      
        </div>
        </div>
        <Workshopbanner></Workshopbanner>
        <div><Footer></Footer></div>

        
   </>
  )}
